import CeleroApiKeyHtml        from './celero.api-key.html';
import CeleroManualPaymentHtml from './celero.manual-payment.html';
import CeleroTerminalHtml      from './celero.terminal.html';

export function CeleroService (
  $uibModal,
  $q,
  $rootScope,
  customerPaymentApi,
  sessionObjAPI,
  workshopAPI
) {
  const Celero = function (settings = $rootScope.Company.company.tnp_settings) {
    this.$uibModal  = $uibModal;
    this.$q         = $q;
    this.$rootScope = $rootScope;

    this.sessionObjAPI = sessionObjAPI;
    this.workshopAPI   = workshopAPI;

    this.settings = settings;
  };

  Celero.prototype.authorize = function () {
    const self = this;

    return self.workshopAPI.get('/company_integrations/add_tnp')
      .then(() => self.sessionObjAPI.refresh());
  };

  Celero.prototype.chooseTerminal = function () {
    const self = this;

    return self.hasMultipleTerminals() ?
      self.$uibModal.open({
        controller: 'CeleroTerminalCtrl',
        controllerAs: '$ctrl',
        resolve: {
          terminals () {
            return self.getTerminals();
          }
        },
        size: 'sm',
        templateUrl: CeleroTerminalHtml
      }).result :
      self.$q.when({
        id: self.sessionObjAPI.user().default_pos_terminal_id
      });
  };

  Celero.prototype.deleteTerminal = function (terminal = {}) {
    return workshopAPI.delete('/pos_terminal', terminal.id);
  };

  Celero.prototype.enterCardManually = function (invoice = {}, payment = {}) {
    const self = this;

      return $uibModal.open({
        templateUrl: CeleroManualPaymentHtml,
        controller: 'CeleroManualPaymentCtrl',
        resolve: {
          celero () {
            return self;
          },
          invoice () {
            return invoice;
          },
          payment () {
            return payment;
          }
        }
      }).result
      .then(() => self.sessionObjAPI.refresh());
  };

  Celero.prototype.getPaymentTotal = function (payment = {}) {
    return customerPaymentApi.getPosPaymentTotal(payment);
  };

  Celero.prototype.getPublicKey = function (terminal = {}) {
    const self = this;

    if (!self.hasMultipleTerminals() || !terminal.id) {
      return self.$q.when(self.settings.tnp_public_key);
    }

    return self.workshopAPI.get('/pos_terminal/get_terminal_details', terminal.id)
      .then(terminal => terminal.tnp_public_key);
  };

  Celero.prototype.getTerminals = function () {
    const self = this;

    return self.workshopAPI.get('/pos_terminals/tnp_terminal_list', [
      0,
      '*',
      'pos_terminal_name',
      'asc'
    ]);
  };

  Celero.prototype.getUrl = function () {
    const self = this;

    return self.workshopAPI.get('/transnational_payments/get_tnp_url');
  };

  Celero.prototype.hasApiKey = function () {
    const self = this;

    return self.settings.has_tnp_api_key;
  };

  Celero.prototype.hasMultipleTerminals = function () {
    const self = this;

    return self.settings.tnp_multiple_terminals;
  };

  Celero.prototype.hasPublicKey = function () {
    const self = this;

    return self.settings.tnp_public_key;
  };

  Celero.prototype.process = function (body = {}) {
    const self = this;

    return self.workshopAPI.post('/transnational_payments/process_payment', body);
  };

  Celero.prototype.saveApiKey = function (key = '') {
    const self = this;

    return self.workshopAPI.post('/transnational_payments/update_private_api_key', {
      tnp_api_key: key
    });
  };

  Celero.prototype.saveSettings = function (terminal = {}) {
    const self = this;

    if (self.hasMultipleTerminals()) {
      return workshopAPI.post('/pos_terminal', {
        tnp_terminal_id  : terminal.id,
        pos_terminal_name: terminal.name,
        tnp_public_key   : self.settings.tnp_public_key
      }, 'pos_terminal');
    }

    self.settings.tnp_public_key  = terminal.publicKey;
    self.settings.tnp_terminal_id = terminal.id;

    return workshopAPI.patch('/company_integrations', self.settings);
  };

  Celero.prototype.setApiKey = function () {
    const self = this;

    return self.$uibModal.open({
      templateUrl: CeleroApiKeyHtml,
      controller : 'CeleroApiKeyCtrl'
    }).result;
  };

  Celero.prototype.unauthorize = function () {
    const self = this;

    return self.workshopAPI.get('/company_integrations/remove_tnp')
      .then(() => self.sessionObjAPI.refresh());
  };

  return Celero;
}
